import React from 'react';
import { Tag, Divider } from 'rsuite';
import { Card } from 'Components/Common/Card/Card';

export const RecepcionMH = (props) => {
  const { recepcion, estatus } = props;

  return (
    <>
      {estatus.estatusRecibidoMH === 1 && (
        <Card header={'Información de la recepción en el Ministerio de hacienda'}>
          <dl>
            <dt>Versión de Respuesta</dt>
            <dd>
              <Tag size="md" color="blue">
                Versión {recepcion.version}
              </Tag>
            </dd>
            <dt>Versión de aplicación</dt>
            <dd>
              <Tag size="md" color={'cyan'}>
                Versión {recepcion.versionApp}
              </Tag>
            </dd>
            <dt>Ambiente de Ejecución</dt>
            <dd>
              {
                {
                  '00': 'Modo Prueba',
                  '01': 'Modo Producción',
                }[recepcion.ambiente]
              }
            </dd>
            <dt>Estado resultado del procesamiento</dt>
            <dd>{recepcion.estado}</dd>
            <dt>Código de generación de DTE</dt>
            <dd>{recepcion.codigoGeneracion}</dd>
            <dt>Sello de Recepción del DTE Aceptado</dt>
            <dd>
              <Tag size="md">{recepcion.selloRecibido}</Tag>
            </dd>
            <dt>Fecha y hora de procesamiento</dt>
            <dd>
              <Tag size="md">{recepcion.fhProcesamiento}</Tag>
            </dd>
            <dt>Código de clasificación de mensaje</dt>
            <dd>{recepcion.clasificaMsg}</dd>
            <dt>Código de Mensaje</dt>
            <dd>{recepcion.codigoMsg}</dd>
            <dt>Descripción del Mensaje</dt>
            <dd>{recepcion.descripcionMsg}</dd>
            {recepcion.observaciones?.length > 0 && (
              <>
                <dt>Detalle de observaciones de validación del DTE</dt>
                <dd>
                  <ul>
                    {recepcion.observaciones.map((o, i) => (
                      <li key={i}>{o}</li>
                    ))}
                  </ul>
                </dd>
              </>
            )}
          </dl>
        </Card>
      )}
      {estatus.estatusRecibidoMH === 2 && (
        <Card header={'Información de la recepción en el Ministerio de hacienda'}>
          <dl>
            <dt>Versión de Respuesta</dt>
            <dd>
              <Tag size="md" color="blue">
                Versión {recepcion.version}
              </Tag>
            </dd>
            <dt>Versión de aplicación</dt>
            <dd>
              <Tag size="md" color={'cyan'}>
                Versión {recepcion.versionApp}
              </Tag>
            </dd>
            <dt>Ambiente de Ejecución</dt>
            <dd>
              {
                {
                  '00': 'Modo Prueba',
                  '01': 'Modo Producción',
                }[recepcion.ambiente]
              }
            </dd>
            <dt>Estado resultado del procesamiento</dt>
            <dd>
              <Tag size="md" color={'red'}>
                {recepcion.estado}
              </Tag>
            </dd>
            <Divider>Información del rechazo</Divider>
            <dt>Código de Mensaje</dt>
            <dd>{recepcion.codigoMsg}</dd>
            <dt>Descripción del Mensaje</dt>
            <dd>{recepcion.descripcionMsg}</dd>
            {recepcion.observaciones?.length > 0 && (
              <>
                <dt>Detalle de observaciones de validación del DTE</dt>
                <dd>
                  <ul>
                    {recepcion.observaciones.map((o, i) => (
                      <li key={i}>{o}</li>
                    ))}
                  </ul>
                </dd>
              </>
            )}
          </dl>
        </Card>
      )}
      {estatus.estatusRecibidoMH === 3 && (
        <Card header={'Información de la recepción en el Ministerio de hacienda'}>
          <div style={{ flex: 1, justifyContent: 'center', alignItems: 'center', marginBottom: 10 }}>
            <Tag color="orange">Recepción por contingencia</Tag>
          </div>
          <Divider>¿Por qué no se transmitió este documento?</Divider>
          <p>No se ha podido realizar la transmisión de este documento electrónico a la Administración Tributaria debido a contingencia.</p>
          <p>En cuanto se ranude la comunicación con el ministerio de hacienda, se notificará el mismo...</p>
        </Card>
      )}
      {estatus.estatusRecibidoMH === 0 && (
        <Card header={'Información de la recepción en el Ministerio de hacienda'}>
          <div style={{ flex: 1, justifyContent: 'center', alignItems: 'center', marginBottom: 10 }}>
            <Tag color="red">No transmitido</Tag>
          </div>
          <p>No se ha realizado la transmisión de este documento electrónico al ministerio de hacienda.</p>
        </Card>
      )}
    </>
  );
};
